import request from "@/utils/request";

// 登录方法
export function login({ username, password }) {
  const data = {
    username,
    password,
    clientType: "pc",
  };
  return request({
    url: "/userInfo/login",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 注册方法
export function register(data) {
  return request({
    url: "/register",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/userInfo/getCurrentUserInfo",
    method: "post",
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/userInfo/logout",
    method: "post",
  });
}

// 首页 人员学习培训信息查询
export function queryLearningLengthByTeacher(data) {
  return request({
    url: "/teacherTraining/queryLearningLengthByTeacher",
    method: "post",
    data: data ? data : ""
  });
}
// 首页 图表数据
export function queryLearningLengthBySchool() {
  return request({
    url: "/teacherTraining/queryLearningLengthBySchool",
    method: "post",
    data: {
      year: 2023
    },
  });
}
